// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading__hgUaa_a8f1{white-space:nowrap;text-overflow:ellipsis}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/integrations/elevio/src/components/ArticleContent/CategoryTags.module.scss"],"names":[],"mappings":"AAAA,qBACE,kBAAA,CACA,sBAAA","sourcesContent":[".heading {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `heading__hgUaa_a8f1`
};
export default ___CSS_LOADER_EXPORT___;
